import { Injectable } from '@angular/core';
import { EMPTY, Observable, ReplaySubject, Subscription, timer } from 'rxjs';
import { catchError, filter, switchMap, tap } from 'rxjs/operators';
import { IdleService } from '../shared/services/idle.service';
import { NotificationsService } from './notifications.service';

@Injectable({ providedIn: 'root' })
export class NotificationsPollingService {
  private notifications$ = new ReplaySubject<any>(1);
  private isPolling = false;
  private intervalSeconds: number;
  private pollingSub?: Subscription;

  constructor(
    private idleService: IdleService,
    private notificationsService: NotificationsService) { }

  beginPolling(intervalSeconds: number, userIdleTimeout: number,
    jsonFilter: string, jsonSort: string, offset: number, limit: number): void {
    if (this.isPolling) return;
    this.idleService.beginIdleDetection(userIdleTimeout);
    this.isPolling = true;
    this.intervalSeconds = intervalSeconds;
    this.pollingSub = timer(0, this.intervalSeconds * 1000).pipe(
      filter(() => !this.idleService.checkIsIdle()),
      switchMap(() => this.notificationsService.getData(jsonFilter, jsonSort, offset, limit).pipe(
        catchError(() => EMPTY)
      )),
      tap(data => this.notifications$.next(data))
    ).subscribe();
  }

  cancelPolling(): void {
    this.isPolling = false;
    this.pollingSub?.unsubscribe();
    this.pollingSub = undefined;
    this.idleService.cancelIdleDetection();
  }

  checkIsPolling(): boolean {
    return this.isPolling;
  }

  get(): Observable<any> {
    return this.notifications$;
  }
}
